import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/icon/arrow_down_filling.png';

const _withScopeId = n => (_pushScopeId("data-v-4d0b2f06"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "entrust-select-c"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

import { ref } from 'vue';
import { useI18n } from "vue-i18n";
export default {
  __name: 'EntrustSelect',
  props: {
    entrustType: {
      type: Number
    },
    popoverW: {
      type: String
    },
    size: {
      type: Number,
      default: 1
    }
  },
  emits: ["entrustChange"],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      t
    } = useI18n();
    const entrustShow = ref(false);

    const entrustChange = entrust => {
      emit("entrustChange", entrust);
      entrustShow.value = false;
    };

    const getItemClass = index => {
      const classList = [];

      if (props.size) {
        classList.push('trade-popover-item');
      } else {
        classList.push('popover-item-s');
      }

      if (index === props.entrustType) {
        classList.push('trade-popover-active');
      }

      return classList;
    };

    return (_ctx, _cache) => {
      const _component_van_popover = _resolveComponent("van-popover");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popover, {
        show: entrustShow.value,
        "onUpdate:show": _cache[2] || (_cache[2] = $event => entrustShow.value = $event),
        "show-arrow": false,
        overlay: "",
        placement: "bottom-start",
        style: {
          "--van-popover-border-radius": "5px"
        }
      }, {
        reference: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([props.size ? 'entrust-option' : 'entrust-option-s'])
        }, [_createElementVNode("span", null, _toDisplayString(props.entrustType ? _unref(t)('marketOrder') : _unref(t)('limitOrder')), 1), _hoisted_2], 2)]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass([props.size ? 'trade-popover-action' : 'popover-action-s']),
          style: _normalizeStyle({
            width: props.popoverW
          })
        }, [_createElementVNode("div", {
          class: _normalizeClass(getItemClass(1)),
          onClick: _cache[0] || (_cache[0] = $event => entrustChange(1))
        }, _toDisplayString(_unref(t)('marketOrder')), 3), _createElementVNode("div", {
          class: _normalizeClass(getItemClass(0)),
          onClick: _cache[1] || (_cache[1] = $event => entrustChange(0))
        }, _toDisplayString(_unref(t)('limitOrder')), 3)], 6)]),
        _: 1
      }, 8, ["show"])]);
    };
  }

};